<template>
  <div>
    <v-row v-if="hasBreadcrumbs">
      <v-col
        cols="12"
        class="pt-0 pb-0"
        style="min-height: 40px"
      >
        <breadcrumbs :items="breadcrumbs" />
      </v-col>
    </v-row>

    <v-row class="pb-2" align="center">
      <v-col v-if="back" cols="auto" style="margin-right: 160px">
        <a :href="back.link" class="page-header__prev-link">
          <svg
            width="32"
            height="14"
            viewBox="0 0 32 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M32 7H1M1 7L7 1M1 7L7 13" stroke="#C7C7C7" />
          </svg>

          <span>{{ back.title }}</span>
        </a>
      </v-col>

      <v-col cols="auto" class="mr-auto">
        <page-title>{{ title }}</page-title>
      </v-col>

      <slot name="buttons" />
    </v-row>

    <slot name="footer" />
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";

import { mapGetters } from "vuex";
import PageTitle from "@/components/PageTitle";

export default {
  name: "PageHeader",
  components: {
    PageTitle,
    Breadcrumbs
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    hasBreadcrumbs: {
      type: Boolean,
      default: true
    },
    back: {
      type: [Object, null],
      default: null
    }
  },
  computed: {
    ...mapGetters({
      breadcrumbs: "breadcrumbs"
    })
  }
};
</script>

<style lang="scss" scoped>
.page-header__prev-link {
  display: flex;
  align-items: center;
  color: #c7c7c7;
  text-decoration: none;

  span {
    padding-left: 8px;
  }
}
</style>
